import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { isUndefined, orderBy } from 'lodash';

/**
 * GetRiskTrendReport
 *
 * Retrieves a list of risk record changes by attribute type and record type.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetRiskTrendReport = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: thePayload,
      headers: {
        'x-api-endpoint': `/dashboard/operational/risk-trend`,
      },
      method: 'POST',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    const response = remoteResponse;

    if (!isUndefined(response?.data?.series)) {
      /**
       * Sort overall data by sourceCode in ascending order, then sort each datapoint from each sourceCode by
       * date in ascending order.
       */
      response.data.series = orderBy(remoteResponse?.data?.series, ['sourceCode'], ['asc']).map((dataset) => {
        const theDataSet = { ...dataset };

        theDataSet.dataPoints = orderBy(
          dataset?.dataPoints,
          [
            (dataPoint) => {
              return dayjs(dataPoint?.date).format('YYYY-MM-DD');
            },
          ],
          ['asc']
        );

        return theDataSet;
      });
    }

    if (!isUndefined(remoteResponse?.data?.sumSeries?.dataPoints)) {
      /**
       * Sort each datapoint in the summary by date in ascending order.
       */
      response.data.sumSeries.dataPoints = remoteResponse?.data?.sumSeries?.dataPoints?.map((dataset) => {
        const theDataSet = { ...dataset };

        theDataSet.dataPoints = orderBy(
          dataset?.dataPoints,
          [
            (dataPoint) => {
              return dayjs(dataPoint?.date).format('YYYY-MM-DD');
            },
          ],
          ['asc']
        );

        return theDataSet;
      });
    }

    return response.data;
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/queries/GetRiskTrendReport.js -> GetRiskTrendReport()',
      false,
      error
    );

    throw error;
  }
};
